import { put } from 'redux-saga/effects'
import { fetchUserPermissionAction } from '../../actions'
import { fetchUserPermission, FetchUserPermissionResponse } from '../_http/user'

export function* fetchUserPermissionSaga(action: ReturnType<typeof fetchUserPermissionAction.request>) {
  try {
    const { companyId, role } = action.payload
    const response: FetchUserPermissionResponse = yield fetchUserPermission({ companyId, role })
    yield put(fetchUserPermissionAction.success({ permission: response.permission }))
  } catch (error) {
    console.log({ fetchUserPermissionSagaError: error })
    yield put(fetchUserPermissionAction.failure())
  }
}
